<i18n src="./resources/locales.json"></i18n>
<template>
  <v-container>
    <v-fade-transition hide-on-leave>
      <v-progress-circular v-if="isLoading" width="2" color="primary" indeterminate class="loading" />
    </v-fade-transition>

    <!-- New Accounts Card / Provision SMS -->
    <v-fade-transition>
      <v-card v-if="!isLoading && !isProvisioned" elevation="2" class="col-6 mt-6 mx-auto">
        <v-card-title>{{ $t('title') }}</v-card-title>
        <v-card-subtitle>{{ $t('subtitles.enable') }}</v-card-subtitle>
        <v-card-text>
          <p>
            {{ $t('text') }}
          </p>
          <p>
            {{ $t('notice') }}
          </p>
          <v-checkbox v-model="acceptAgreement" :label="$t('checkboxLabel')"></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" :loading="isProvisioning" :disabled="!acceptAgreement" @click="provisionSms" dark>
            {{ $t('enableSms') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-fade-transition>

    <!-- SMS Numbers Table for Provisioned Accounts -->
    <v-fade-transition>
      <v-card v-if="!isLoading && isProvisioned" elevation="2">
        <v-card-title>{{ $t('title') }}</v-card-title>
        <v-card-subtitle>{{ $t('subtitles.exists') }}</v-card-subtitle>
        <div>
          <v-data-table :headers="headers" :items="smsDIDs" :items-per-page="15" class="elevation-1">
            <template v-slot:item="row">
              <tr>
                <td>{{ row.item.did }}</td>
                <td>{{ row.item.handlerName }}</td>
                <td>{{ row.item.handlerTypeName }}</td>
                <td>
                  <v-chip v-if="row.item.provisioned" color="success">
                    <v-icon left>mdi-check</v-icon>
                    Provisioned
                  </v-chip>
                  <v-btn v-else color="info" @click="provisionNumber(row.item.did)" small>Provision</v-btn>
                </td>
                <td>
                  <v-btn v-if="row.item.active" color="error" @click="deactivateNumber(row.item)" small
                    >Deactivate</v-btn
                  >
                  <v-btn
                    v-else
                    color="success"
                    :disabled="!row.item.provisioned"
                    @click="activateNumber(row.item)"
                    small
                  >
                    Activate
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-fade-transition>
  </v-container>
</template>

<script>
import SmsService from '@/services/sms.service';
import { mapActions } from 'vuex';

export default {
  name: 'SmsProvisioning',

  data() {
    return {
      isLoading: false,
      acceptAgreement: false,
      isProvisioned: false,
      isProvisioning: false,
      hasSecret: false,
      headers: [
        { text: this.$t('tableHeaders.phoneNumber'), value: 'did' },
        { text: this.$t('tableHeaders.assignment'), value: 'handlerName' },
        { text: this.$t('tableHeaders.type'), value: 'handlerTypeName' },
        { text: this.$t('tableHeaders.provisioned'), value: 'provisioned' },
        { text: this.$t('tableHeaders.active'), value: 'active' }
      ],
      smsDIDs: []
    };
  },

  mounted() {
    this._checkSmsActive();
  },

  methods: {
    ...mapActions(['snackbarErrorMessage', 'snackbarSuccessMessage']),

    /**
     * Activate an SMS number that is already provisioned, but inactive
     * @param {object} did
     */
    activateNumber(did) {
      console.log('Should activate!', did);
    },

    /**
     * Deactivate an SMS number
     * @param {object} did
     */
    deactivateNumber(did) {
      // SmsService.deleteNumber(did).then(() => {
      //   this.snackbarSuccessMessage(`${did} was successfully deactivated`);
      // });
      console.log('Should deactivate', did);
    },

    /**
     * Provision the number to this SMS user via the SMS API
     * AWC-1610
     * @param {string} phoneNumber
     */
    async provisionNumber(phoneNumber) {
      const newNumber = await SmsService.addSmsNumber({ phoneNumber });
      if (newNumber) {
        this.snackbarSuccessMessage(this.$t('messages.phoneNumberAdded'));
      } else {
        this.snackbarErrorMessage(this.$t('messages.unableToAdd'));
      }
    },

    /**
     * Provision SMS for this account
     * AWC-1608
     */
    async provisionSms() {
      const { provisioned, smsNumberList } = await SmsService.provisionSms();
      this.isProvisioned = provisioned;
      this.smsDIDs = smsNumberList;
      if (provisioned === false) {
        this.snackbarErrorMessage(this.$t('messages.unableToProvision'));
      }
    },
    /**
     * Check the status of the SMS account via ECS Configuration
     * and SMS API data and set the appropriate values for the UI
     * AWC-1607
     * @private
     */
    async _checkSmsActive() {
      this.isLoading = true;
      const { provisioned, smsNumberList } = await SmsService.getSmsInformation();
      this.isProvisioned = provisioned;
      this.smsDIDs = smsNumberList;
      this.isLoading = false;
    }
  }
};
</script>

<style scoped lang="scss">
.loading {
  display: block;
  margin: 100px auto;
}
</style>
